// import { Router } from "vue-router";

const globalRouter = { router: null };

export { globalRouter };